import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { useTranslation } from 'react-i18next';

// style
import styles from './style';

const useStyles = makeStyles(styles);

export default function DamLegend() {
  const { t } = useTranslation();
  const classes = useStyles();

  function Row() {
    return (
      <>
        <div id="legend" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.one}`}>{'<=30'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('น้อยวิกฤต')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.two}`}>{'>30'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('น้อย')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.three}`}>{'>50'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('ปกติ')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.four}`}>{'>80'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('มาก')}</Box>
            </Box>
          </Grid>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.five}`}>{'>100'}</Box>
              <Box p={(0.5)} className={classes.title}>{t('เกินความจุ')}</Box>
            </Box>
          </Grid>
        </div>
        <div id="legend" style={{ display: 'flex', flexDirection: 'row', width: '40%' }}>
          <Grid item xs className={classes.boxLevel}>
            <Box>
              <Box p={(0.5)} className={`${classes.color} ${classes.zero}`}>-</Box>
              <Box p={(0.5)} className={classes.title}>{t('ข้อมูลรอปรับปรุง / ไม่มีข้อมูลรายวัน')}</Box>
            </Box>
          </Grid>
        </div>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Row />
      </Grid>
    </div>
  );
}
